import React from 'react';
import { Box } from '@cp/ds/src/components/box';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks/useTheme';
import { CheckmarkIcon, CloseIcon } from '@cp/ds/src/icons';
import { AI_IMAGE_GENERATOR_CONSTANTS, dashedBorderSx } from '../lib';
import { GenerationStatusItem } from '../types';

interface GenerationStatusCardProps {
  status: GenerationStatusItem;
  onDismiss?: () => void;
}

export const GenerationStatusCard: React.FC<GenerationStatusCardProps> = ({ status, onDismiss }) => {
  const theme = useTheme();
  const isError = status.kind === 'error';

  return (
    <Box
      sx={{
        width: '100%',
        flexShrink: 0,
        height: 94,
        minHeight: 94,
        px: 2.5,
        py: 1.5,
        borderRadius: AI_IMAGE_GENERATOR_CONSTANTS.BORDER_RADIUS,
        backgroundColor: isError ? 'rgba(255, 120, 112, 0.08)' : 'rgba(34, 195, 75, 0.08)',
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        ...(isError ? dashedBorderSx.error : dashedBorderSx.success),
      }}
    >
      <Stack alignItems="center" direction="row" spacing={0.75} sx={{ mb: 0.5 }}>
        {isError ? (
          <CloseIcon
            onClick={onDismiss}
            sx={{ color: theme.palette['brand pink'], fontSize: 24, cursor: onDismiss ? 'pointer' : 'default' }}
          />
        ) : (
          <CheckmarkIcon sx={{ color: AI_IMAGE_GENERATOR_CONSTANTS.SUCCESS_BORDER_COLOR, fontSize: 24 }} />
        )}
        <Typography variant="h6">{isError ? 'Ошибка генерации' : 'Задача успешно создана'}</Typography>
      </Stack>
      <Typography color="text.secondary" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} variant="body">
        {isError ? status.message || 'Ошибка на стороне сервера или ИИ' : 'Ожидание результата генерации..'}
      </Typography>
    </Box>
  );
};
